<template>
    <div class="features-model" id="part4" ref="part4">
        <div class="part_section" id="section1"></div>
        <div class="swiper">
          <template v-if="featuresUrls.length > 1">
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide v-for="(item,index) in featuresUrls" :key="index"><a :href="item.linkUrl" target="_blank"><img :src="item.imageUrl"/></a></swiper-slide>
              <div class="swiper-button-prev" slot="button-prev">
                <img src="https://resource.rcclchina.com.cn/cruiseDetail/swiper/swiper-btn-left.png"/>
              </div>
              <div class="swiper-button-next" slot="button-next">
                <img src="https://resource.rcclchina.com.cn/cruiseDetail/swiper/swiper-btn-right.png"/>
              </div>
            </swiper>
          </template>
          <template v-else>
            <img :src="featuresUrls[0].url"/>
          </template>

        </div>
    </div>
</template>

<script>

// import api from '@/api'
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  name: "CruiseDetailFeatures",
  components: {
    Swiper,
    SwiperSlide
  },
    props: {
      featuresUrls: {
          type: Array
      }
    },
    data () {
        return {
          swiperOption: {
            loop: true,
            pagination: {
              el: '.swiper-pagination',
              type: 'fraction'
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
          }
        }
    },
    methods: {
    },
    computed: {
    },
    watch: {
    }
}
</script>

<style lang="less" scoped>
.features-model {
  margin: 20px auto;
  position: relative;
  height: 400px;
  width: 1200px;
  & .swiper {
    & .swiper-slide > a {
      display: block;
      width: 100%;
      height: 400px;
      & .swiper-slide > img {
        width: 100%;
        height: 400px;
      }
    }
    & .swiper-button-next,
    & .swiper-button-prev {
      width: 80px;
      height: 100px;
      top: 42.5%;
    }
    & .swiper-button-next:after,
    & .swiper-button-prev:after {
      content: none;
    }
  }
}
.part_section {
  position: absolute;
  top: -50px;
}
</style>